import React from 'react';
import styled from '@emotion/styled';
import i18n from 'i18next';
import {connect} from 'react-redux';
import mapStateToProps from '../../redux/util';

const Footer = (props = {}) => {
    const { color = '#000', locale } = props;
    return (
        <Container>
            <CopyRight color={ color }>
                <a href="https://qingping.co" target="_blank"
                   rel="noopener noreferrer">{ i18n.t('qingping') }</a>
            </CopyRight>
            { locale !== 'en' && <Register color={ color }>粤ICP备19156805号 <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502004977"
                target="_blank" rel="noopener noreferrer">粤公网安备44030502004977号</a>
            </Register> }
        </Container>
    );
};


const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 190px;
  display: flex;
  justify-content: space-between;
`;
const CopyRight = styled.div`
  font-size: 10px;
  height: 40px;
  line-height: 40px;
  opacity: .7;

  a {
    color: ${ props => props.color };
    text-decoration: underline;
  }
`;

const Register = styled.div`
  height: 40px;
  line-height: 40px;
  font-size: 10px;
  font-weight: 400;
  opacity: .7;
  color: ${ props => props.color };

  a {
    color: ${ props => props.color };
    text-decoration: underline;
  }
`;

export default connect(mapStateToProps)(Footer);


